import { AbstractFacade, plainToInstanceWithLVS } from '@goparrot/common';
import deepmerge from 'deepmerge';
import { SearchResultsDto, TagCountDto } from '../dto';
import { ReadUserDto, ReadUserSubscriptionDto } from '../generated-dto';
import { isSmartSearch, UserExposeGroup } from '../interface';
export class UserFacade extends AbstractFacade {
    constructor(config = {}, interceptors) {
        super(deepmerge({
            axiosConfig: {
                baseURL: process.env.GOPARROT_PLATFORM_SERVICE_CUSTOMER,
            },
        }, config), interceptors);
    }
    async search(data, offset, limit) {
        const path = isSmartSearch(data) ? 'smart-search' : 'search';
        return plainToInstanceWithLVS(SearchResultsDto, (await this.client.post(`api/v2/users/${path}`, data, {
            params: {
                offset: offset || 0,
                limit: limit || 20,
            },
        })).data, { groups: [UserExposeGroup.SEARCH_RESULT] });
    }
    async create(data, storeId) {
        return plainToInstanceWithLVS(ReadUserDto, (await this.client.post(`api/v2/users`, data, {
            params: {
                storeId,
            },
        })).data, {
            groups: [UserExposeGroup.READ],
        });
    }
    async getCountByTags(merchantId) {
        return plainToInstanceWithLVS(TagCountDto, (await this.client.get(`api/v2/merchants/${merchantId}/users/count-by-tags`)).data);
    }
    async get(userId, query) {
        return plainToInstanceWithLVS(ReadUserDto, (await this.client.get(`api/v2/users/${userId}`, {
            params: query,
        })).data, {
            groups: [UserExposeGroup.READ],
        });
    }
    async delete(userId) {
        await this.client.delete(`api/v2/users/${userId}`);
    }
    async patch(userId, data) {
        return plainToInstanceWithLVS(ReadUserDto, (await this.client.patch(`api/v2/users/${userId}`, data)).data, {
            groups: [UserExposeGroup.READ],
        });
    }
    async getUserSubscription(userId) {
        return plainToInstanceWithLVS(ReadUserSubscriptionDto, (await this.client.get(`api/v2/users/${userId}/subscription`)).data, {
            groups: [UserExposeGroup.READ],
        });
    }
}
//# sourceMappingURL=user.facade.js.map